module.exports = __webpack_public_path__ + "7eed77f4cb04e9cb678c17eba85afd1e.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/183.png
// module id = 1766
// module chunks = 2